// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__kMXp6","logo_top":"Nav_logo_top__HURBE"};